const PAD = [
  { k: "ArrowUp", code: "ArrowUp", label: "▲", cls: "col-start-2 row-start-1" },
  { k: "ArrowLeft", code: "ArrowLeft", label: "◀", cls: "col-start-1 row-start-2" },
  { k: "ArrowRight", code: "ArrowRight", label: "▶", cls: "col-start-3 row-start-2" },
  { k: "ArrowDown", code: "ArrowDown", label: "▼", cls: "col-start-2 row-start-3" },
];
const BTNS = [
  { k: "x", code: "KeyX", label: "A" },
  { k: "z", code: "KeyZ", label: "B" },
  { k: "Enter", code: "Enter", label: "Start" },
];

function Btn({ b, send, className }) {
  const press = (a) => (e) => { e.preventDefault(); send({ t: "k", a, key: b.k, code: b.code }); };
  return (
    <button type="button" data-play-ui data-testid={`vpad-${b.code.toLowerCase()}`} aria-label={b.label}
      onPointerDown={press("down")} onPointerUp={press("up")} onPointerLeave={press("up")} onPointerCancel={press("up")}
      className={`select-none touch-none rounded-full bg-[#fff]/15 border border-[#fff]/25 text-[#fff] font-bold backdrop-blur-sm active:bg-volt/60 ${className}`}>
      {b.label}
    </button>
  );
}

export function VirtualPad({ send }) {
  return (
    <div data-testid="virtual-pad" className="pointer-events-none absolute inset-x-0 bottom-0 p-4 flex items-end justify-between">
      <div className="pointer-events-auto grid grid-cols-3 grid-rows-3 gap-1 w-36 h-36">
        {PAD.map((b) => <Btn key={b.k} b={b} send={send} className={`${b.cls} w-12 h-12 text-sm`} />)}
      </div>
      <div className="pointer-events-auto flex items-end gap-2">
        <Btn b={BTNS[2]} send={send} className="h-9 px-3 text-xs mb-1 mr-7" />
        <div className="flex flex-col gap-2">
          <Btn b={BTNS[0]} send={send} className="w-14 h-14" />
          <Btn b={BTNS[1]} send={send} className="w-14 h-14 -ml-8" />
        </div>
      </div>
    </div>
  );
}
